import type { ReactNode } from "react";
import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

const CARDS: ReadonlyArray<readonly [number, number, (x: number, y: number) => ReactNode]> = [
  [32, 30, (x, y) => <circle cx={x + 22} cy={y + 18} r="7" fill={c.p400} />],
  [84, 30, (x, y) => <path d={`M${x + 22} ${y + 10}l8 14h-16z`} fill={c.a400} />],
  [32, 86, (x, y) => <rect x={x + 15} y={y + 11} width="14" height="14" rx="3" fill={c.s300} />],
  [84, 86, (x, y) => <path d={`M${x + 22} ${y + 9}l8 9-8 9-8-9z`} fill={c.p500} />],
];

export function CatalogIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      {CARDS.map(([x, y, shape]) => (
        <g key={`${x}-${y}`}>
          <rect
            x={x}
            y={y}
            width="44"
            height="50"
            rx="8"
            fill={c.n0}
            stroke={c.p200}
            strokeWidth="2"
          />
          <rect x={x + 6} y={y + 6} width="32" height="24" rx="5" fill={c.p100} />
          {shape(x, y)}
          <rect x={x + 12} y={y + 36} width="20" height="5" rx="2.5" fill={c.p300} />
          <rect x={x + 16} y={y + 43} width="12" height="3" rx="1.5" fill={c.a300} />
        </g>
      ))}
    </Frame>
  );
}
